import BaseErrorCard from 'reservations/base/components/BaseErrorCard';

const SYSTEM_ERROR_TITLE = "Sorry, we're experiencing technical issues";

const SYSTEM_ERROR_CONTENT =
  "Something isn't working as expected and we're unable to load reservations right now. Please try reloading the page, or navigating back.";

type SystemErrorProps = {
  errorContent?: string;
  errorTitle?: string;
};

function SystemError({ errorTitle, errorContent }: SystemErrorProps) {
  return (
    <BaseErrorCard
      title={errorTitle || SYSTEM_ERROR_TITLE}
      content={errorContent || SYSTEM_ERROR_CONTENT}
      linkText="Return to homepage"
      linkHref="/locations"
    />
  );
}

export default SystemError;
